module.exports = __webpack_public_path__ + "img/Banner-Labels-FG.d5f111e6.png";